import Manager from "../manager/Manager.api";
import Endpoints from "../endpoints/Endpoints.api";

const login = ({ username, password, language }) =>
  Manager.client().post(Endpoints.privateArea.login, { username, password, language });

const logout = ({ card, idSession, language, cause = 0 }) =>
  Manager.client().post(Endpoints.privateArea.logout, { card, id_sessione: idSession, language, cause });

const checkSession = ({ card, token, language }) =>
  Manager.client().post(Endpoints.privateArea.check_session, { card, token, language });

const lugasRealityCheck = ({ card, token, logged_in, type, language }) =>
  Manager.client().post(Endpoints.privateArea.lugasRealityCheck, { card, token, logged_in, type, language });



export const Request = {
  login,
  logout,
  checkSession,
  lugasRealityCheck
};
